import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

type StyleEntry =
  | SystemStyleObject<Theme>
  | ((theme: Theme) => SystemStyleObject<Theme>);

export const styles = {
  list: {
    flexGrow: 1,
    overflow: 'auto',
  },
  listBottom: {
    marginTop: 'auto',
  },
  logo: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
  }),
  logoText: {
    color: 'white',
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  version: (theme: Theme) => ({
    padding: theme.spacing(1, 2),
  }),
  versionOpen: (theme: Theme) => ({
    padding: theme.spacing(1, 2),
  }),
  versionText: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '0.75rem',
  },
  logout: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  }),
  logoutLight: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  }),
  logoutLightText: {
    color: 'white',
    fontSize: '0.875rem',
  },
  homeText: {
    color: 'white',
    fontSize: '0.875rem',
  },
} satisfies Record<string, StyleEntry>;
